import * as auth from './auth';
import * as loading from './loading';
import * as modal from './modal';
import * as msg from './msg';
import * as overlay from './overlay';
import * as sidebar from './sidebar';

export default {
   auth,
   loading,
   modal,
   msg,
   overlay,
   sidebar
};
